import { render, staticRenderFns } from "./AddNewMenu.vue?vue&type=template&id=cd1e9240"
import script from "./AddNewMenu.vue?vue&type=script&lang=js"
export * from "./AddNewMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports